import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * items: [{ name: "Inicio", path: "/" }, { name: "Estabulación", path: "/estabulacion" }]
 */
export function BreadcrumbLd({ items }) {
  const itemListElement = items.map((it, idx) => ({
    "@type": "ListItem",
    position: idx + 1,
    name: it.name,
    item: `https://madridcampogrande.es${it.path}`,
  }));

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement,
        })}
      </script>
    </Helmet>
  );
}
